import React from 'react'
import { connect } from 'react-redux'
import { Card } from 'semantic-ui-react'

import BillingInvoiceStats from 'components/superuser/billing/BillingInvoiceStats'
import BillingInvoicesListItem from 'components/superuser/billing/BillingInvoicesListItem'
import EntitiesList from 'components/entities/EntitiesList'
import { displayStatus } from 'components/superuser/billing/invoiceStatus'

import { getFilteredBillingInvoices } from 'selectors/billing'

const STATUS_OPTIONS = [
  { key: 'draft',            value: 'draft',            text: 'Draft' },
  { key: 'sending',          value: 'sending',          text: 'Sending' },
  { key: 'issued',           value: 'issued',           text: 'Issued' },
  { key: 'reminded',         value: 'reminded',         text: 'Reminded' },
  { key: 'overdue',          value: 'overdue',          text: 'Overdue' },
  { key: 'overdue_reminded', value: 'overdue_reminded', text: 'Overdue (reminded)' },
  { key: 'paid',             value: 'paid',             text: 'Paid' },
  { key: 'credited',         value: 'credited',         text: 'Credited' },
  { key: 'void',             value: 'void',             text: 'Void' }
]

const mapStateToProps = (state, ownProps) => {
  const filters = [
    { by: 'status', selectOptions: STATUS_OPTIONS, getTarget: (inv) => [displayStatus(inv)] }
  ]

  return {
    entities: getFilteredBillingInvoices(state, filters),
    entityName: 'billingInvoice',
    item: BillingInvoicesListItem,
    listComponent: Card.Group,
    loading: state.meta?.billingInvoice?.loading,
    error: state.meta?.billingInvoice?.error,
    title: 'Invoices',
    filters
  }
}

const InvoicesList = connect(mapStateToProps)(EntitiesList)

export default function BillingInvoicesListContainer () {
  return (
    <React.Fragment>
      <BillingInvoiceStats/>
      <InvoicesList/>
    </React.Fragment>
  )
}
